var app;

- (- (- (-(app = window.App || (window.App = {})))));

app.SubvereinSelect = {
  select_all: function(e) {
    var checked, table;
    checked = e.target.checked;
    table = $(e.target).closest('.checkboxes');
    return table.find('input[type="checkbox"]:not([disabled])').prop('checked', checked);
  }
};

$(document).on('click', '#subgroup-select .checkboxes input#all', app.SubvereinSelect.select_all);
